import React from "react";
import { graphql, compose, withApollo } from "react-apollo";
import gql from "graphql-tag";
import deleteImg from "../../img/delete.svg";
import Button from "./Button";
import loading from "../../img/loading.svg";


class EditPatient extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      //  ...this.props.patient,
      patientError: false,
      confirm: false,
      loadingD: false,
      nom: "",
      prenom: "",
      ville: "",
      portable: "",
      email: "",
      telephone: "",
      adresse: "",
      codepostal: "",
      matricule: ""
    };
  }

  deletePatient = () => {
    let id = this.props.patientId;
    this.setState({
      loadingD: true
    });

    this.props
      .deletePatient({
        variables: {
          id
        }
      })
      .then((data, dd) => {
        //this.props.client.resetStore();
        //remove patient from local state, set cachepolicy
        let selectedPatientId = null;
        let fromCache = false;
        this.props
          .updateRdvSelect({
            variables: {
              selectedPatientId,
              fromCache
            }
          })
          .then(() => {
            this.props.handleChangePatient(null);
            this.props.toggleModal();
          });
      });
  };
  handleInput = (event, variable) => {
    this.setState(
      {
        [variable]: event.target.value,
        //    validMatricule: this.state.matricule.length > 9,
        validNom: this.state.nom.length > 1,
        validPrenom: this.state.prenom.length > 1,
        patientSaved: false,
        patientError: false
      },
      () => this.handleChange(variable)
    );
  };
  handleChange = async variable => {
    const id = this.props.patientId;

    if (
      this.state.prenom.length > 1 &&
      this.state.nom.length
      //    this.state.matricule.length > 9
    ) {
      await this.props
        .updatePatient({
          variables: { id, ...this.state }
        })
        .then(() => {
          //this.props.toggleModal();
          this.setState({
            patientSaved: true,
            patientError: false
          });
        })
        .catch(e => {
          this.setState({
            patientSaved: false,
            patientError: true
          });
          console.error("update patient", e);
        });
    }
  };

  toggleConfirm = () => {
    this.setState({
      confirm: !this.state.confirm
    });
  };

  componentWillReceiveProps(newProps) {
    if (!newProps.getPatientById.loading) {
      let p = newProps.getPatientById.Patient;
      if (p === null) {
      }

      this.setState({
        nom: p.nom,
        prenom: p.prenom,
        ville: p.ville,
        portable: p.portable,
        email: p.email,
        telephone: p.telephone,
        adresse: p.adresse,
        codepostal: p.codepostal,
        matricule: p.matricule
      });
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.state.confirm ? (
          <div className="modal-slot-overlay">
            <div className="modal-slot-overlay-content has-text-centered">
              <h1 className="title">Êtes-vous sûr?</h1>
              <p>
                <Button
                  style={{
                    width: "100px"
                  }}
                  text="Retour"
                  onClick={this.toggleConfirm}
                />
                <Button
                  color="red"
                  text="Oui!"
                  onClick={this.deletePatient}
                  style={{
                    width: "100px"
                  }}
                />
              </p>
              {this.state.loadingD ? (
                <figure className="image is-32x32">
                  <img alt="loading" src={loading} />
                </figure>
              ) : null}
            </div>
          </div>
        ) : null}

        <div className="field">
          <span onClick={this.toggleConfirm}>
            <figure
              className="image is-21x21"
              style={{
                display: "inline-block",
                cursor: "pointer",
                float: "right"
              }}
            >
              <img alt="deleteImg" src={deleteImg} />
            </figure>
          </span>
          {this.state.patientSaved ? (
            <span className="blink tag  is-success">sauvegardé!</span>
          ) : null}
          {this.state.patientError ? (
            <span className="is-pulled-right tag is-danger">erreur!</span>
          ) : null}
          <label className="label">Matricule</label>
          <div className="control">
            <input
              disabled={true}
              className="input"
              value={this.state.matricule}
              type="text"
              placeholder=""
            />
          </div>
        </div>

        <div className="field is-horizontal">
          <div className="field-body">
            <div className="field">
              <label className="label">
                Nom <span className="tag is-warning">obligatoire</span>
              </label>
              <div className="control">
                <input
                  onChange={e => this.handleInput(e, "nom")}
                  className={`input ${this.state.validNom === false
                    ? "is-danger"
                    : ""}
              `}
                  value={this.state.nom}
                  type="text"
                  placeholder=""
                />
              </div>
            </div>
            <div className="field">
              <label className="label">
                Prénom <span className="tag is-warning">obligatoire</span>
              </label>
              <div className="control">
                <input
                  onChange={e => this.handleInput(e, "prenom")}
                  className={`input ${this.state.validPrenom === false
                    ? "is-danger"
                    : ""}
              `}
                  value={this.state.prenom}
                  type="text"
                  placeholder=""
                />
              </div>
            </div>
          </div>
        </div>

        <div className="field is-horizontal">
          <div className="field-body">
            <div className="field">
              <label className="label">Numéro de portable</label>
              <div className="control">
                <input
                  onChange={e => this.handleInput(e, "portable")}
                  className="input"
                  value={this.state.portable || ""}
                  type="text"
                  placeholder=""
                />
              </div>
            </div>
            <div className="field">
              <label className="label">Numéro de téléphone fixe</label>
              <div className="control">
                <input
                  onChange={e => this.handleInput(e, "telephone")}
                  className="input"
                  value={this.state.telephone}
                  type="text"
                  placeholder=""
                />
              </div>
            </div>
          </div>
        </div>

        <div className="field is-horizontal">
          <div className="field-body">
            <div className="field">
              <label className="label">Adresse</label>
              <div className="control">
                <input
                  onChange={e => this.handleInput(e, "adresse")}
                  className="input"
                  value={this.state.adresse}
                  type="text"
                  placeholder=""
                />
              </div>
            </div>
            <div className="field">
              <label className="label">Code postal</label>
              <div className="control">
                <input
                  onChange={e => this.handleInput(e, "codepostal")}
                  className="input"
                  value={this.state.codepostal}
                  type="text"
                  placeholder=""
                />
              </div>
            </div>
          </div>
        </div>
        <div className="field is-horizontal">
          <div className="field-body">
            <div className="field">
              <label className="label">Localité</label>
              <div className="control">
                <input
                  onChange={e => this.handleInput(e, "ville")}
                  className="input"
                  value={this.state.ville}
                  type="text"
                  placeholder=""
                />
              </div>
            </div>
            <div className="field">
              <label className="label">Email</label>
              <div className="control">
                <input
                  onChange={e => this.handleInput(e, "email")}
                  className="input"
                  value={this.state.email}
                  type="text"
                  placeholder=""
                />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

/*
nom: String!
prenom: String!
telephone: String
portable: String
adresse: String
codepostal: String
email: String
ville: String
matricule: String @isUnique
*
 */
const UPDATE_PATIENT = gql`
  mutation updatePatient(
    $id: ID!
    $nom: String
    $prenom: String
    $adresse: String
    $portable: String
    $telephone: String
    $email: String
    $matricule: String
    $ville: String
    $codepostal: String
  ) {
    updatePatient(
      id: $id
      nom: $nom
      prenom: $prenom
      adresse: $adresse
      codepostal: $codepostal
      portable: $portable
      telephone: $telephone
      ville: $ville
      matricule: $matricule
      email: $email
    ) {
      id
    }
  }
`;

const DELETE_PATIENT = gql`
  mutation deletePatientMutation($id: ID!) {
    deletePatient(id: $id) {
      id
    }
  }
`;

const UPDATE_RDV_SELECT = gql`
  mutation updateRDVSelect($selectedPatientId: String, $fromCache: Boolean) {
    updateRDVSelect(
      selectedPatientId: $selectedPatientId
      fromCache: $fromCache
    ) @client
  }
`;

const PATIENTS_SEARCH_BY_ID = gql`
  query getPatientById($patientId: ID!) {
    Patient(id: $patientId) {
      id
      nom
      prenom
      matricule
      telephone
      portable
      email
      adresse
      codepostal
      ville
    }
  }
`;

export default compose(
  graphql(UPDATE_PATIENT, {
    name: "updatePatient"
  }),
  graphql(DELETE_PATIENT, {
    name: "deletePatient"
  }),
  graphql(PATIENTS_SEARCH_BY_ID, {
    name: "getPatientById",
    options: ({ patientId }) => ({ variables: { patientId } }),
    skip: ({ patientId }) => patientId === null
  }),
  graphql(UPDATE_RDV_SELECT, {
    name: "updateRdvSelect"
    //  options: ({ doctorId }) => ({ variables: { doctorId } })
  }),
  withApollo
)(EditPatient);



// WEBPACK FOOTER //
// ./src/components/utilities/EditPatient.js